import { type QueryKey, useQueryClient } from "@tanstack/react-query";

export const useRosterAndStaffQueryDataUpdater = () => {
  const queryClient = useQueryClient();

  return {
    deleteRecords: (queryKey: QueryKey, response: any, personIds?: Array<string>, dcPersonIds?: Array<string>) => {
      if (!response?.data?.[0]?.success) {
        return false;
      }

      queryClient.setQueryData(queryKey, (oldResponse: any) => {
        if (!oldResponse) {
          return oldResponse;
        }
        return {
          ...oldResponse,
          data: (oldResponse.data || []).filter(
            (x: any) => !personIds?.includes(x.personId) && !dcPersonIds?.includes(x.dcPersonId)
          ),
        };
      });

      return true;
    },
    addRecords: (queryKey: QueryKey, response: any) => {
      if (!response?.data) {
        return false;
      }

      queryClient.setQueryData(queryKey, (oldResponse: any) => {
        if (!oldResponse) {
          oldResponse = {};
        }
        return {
          ...oldResponse,
          data: oldResponse.data ? [...oldResponse.data, ...response.data] : [response.data],
        };
      });

      return true;
    },
    replaceRecords: (queryKey: QueryKey, response: any) => {
      if ((response?.data || []).length === 0) {
        return;
      }

      const personIds = response.data.filter((x: any) => x.personId).map((x: any) => x.personId);
      const dcPersonIds = response.data.filter((x: any): any => x.dcPersonId).map((x: any) => x.dcPersonId);

      queryClient.setQueryData(queryKey, (oldResponse: any) => {
        if (!oldResponse) {
          oldResponse = {};
        }
        const oldDataWithoutRecordsToBeReplaced = (oldResponse.data || []).filter(
          (x: any) => !personIds.includes(x.personId) && !dcPersonIds.includes(x.dcPersonId)
        );
        return {
          ...oldResponse,
          data: [...oldDataWithoutRecordsToBeReplaced, ...response.data],
        };
      });
    },
  };
};
